export default __webpack_public_path__ + "svg/CompaniesLogos/logo_integrarobot.svg?a06298cd";